import React from 'react'

function Footer() {
  return (
    <div className='w-full h-[600px] bg-red-600 p-32'>
        <span className='text-6xl text-white italic font-bold'>Footer</span>
    </div>
  )
}

export default Footer;